<template>
  <el-select v-model="value" placeholder="请选择" @change="changeValue($event)" clearable>
    <el-option
      v-for="item in teamData"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      teamData: [],
      callbackMethod: ''
    }
  },
  methods: {
    changeValue(e) {
      this.$emit(this.callbackMethod, this.value)
    },
    setSelectValue(value) {
      this.value = value
    },
    initDict(teamData) {
      this.teamData = teamData
    },
    initData(teamData,callbackMethod) {
      this.teamData = JSON.parse(JSON.stringify(teamData))
      this.callbackMethod = callbackMethod
    }
  }
}
</script>
